import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "vevo-detail-wrapper" }
const _hoisted_2 = { class: "vevo-topbar" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "vevo-topbar-title" }
const _hoisted_5 = {
  key: 1,
  class: "vevo-topbar-spacer"
}
const _hoisted_6 = {
  key: 0,
  class: "d-flex justify-center pa-6"
}
const _hoisted_7 = {
  key: 1,
  class: "vevo-empty"
}
const _hoisted_8 = {
  key: 2,
  class: "vevo-detail-body"
}
const _hoisted_9 = { class: "vevo-detail-card" }
const _hoisted_10 = { class: "vevo-detail-header" }
const _hoisted_11 = { class: "vevo-detail-icon-wrap" }
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 0,
  class: "vevo-new-badge"
}
const _hoisted_14 = { class: "vevo-detail-titlewrap" }
const _hoisted_15 = { class: "vevo-detail-date" }
const _hoisted_16 = { class: "vevo-detail-title" }
const _hoisted_17 = {
  key: 0,
  class: "vevo-coverage-note"
}
const _hoisted_18 = { class: "vevo-coverage-note caution-text" }
const _hoisted_19 = { class: "vevo-detail-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_btn, {
        icon: "",
        variant: "text",
        size: "small",
        class: "vevo-back-btn",
        onClick: _ctx.goBack,
        ripple: false
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _ctx.chevronLeftIcon,
            alt: "back",
            class: "vevo-back-icon"
          }, null, 8, _hoisted_3)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.t('vevo.detail.title')), 1),
      (_ctx.detail)
        ? (_openBlock(), _createBlock(_component_v_menu, {
            key: 0,
            modelValue: _ctx.languageMenuOpen,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.languageMenuOpen) = $event)),
            location: "bottom end",
            offset: "4",
            "close-on-content-click": true
          }, {
            activator: _withCtx(({ props: menuProps }) => [
              _createVNode(_component_v_btn, _mergeProps(menuProps, {
                icon: "",
                variant: "text",
                size: "small",
                class: "vevo-lang-btn",
                ripple: false,
                "aria-label": _ctx.t('vevo.detail.language')
              }), {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    color: "white",
                    size: "22"
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode("mdi-translate", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 16, ["aria-label"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_list, {
                density: "compact",
                class: "vevo-lang-menu",
                "min-width": "160"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languageOptions, (option) => {
                    return (_openBlock(), _createBlock(_component_v_list_item, {
                      key: option.code,
                      active: option.code === _ctx.selectedLanguage,
                      onClick: ($event: any) => (_ctx.selectLanguage(option.code))
                    }, {
                      append: _withCtx(() => [
                        (option.code === _ctx.selectedLanguage)
                          ? (_openBlock(), _createBlock(_component_v_icon, {
                              key: 0,
                              size: "18",
                              color: "primary"
                            }, {
                              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                _createTextVNode(" mdi-check ", -1)
                              ]))]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(option.label), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["active", "onClick"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5))
    ]),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: "primary"
          })
        ]))
      : (!_ctx.detail)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.t('vevo.detail.notFound')), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("img", {
                    src: _ctx.envelopeIconRead,
                    alt: "",
                    class: "vevo-detail-icon"
                  }, null, 8, _hoisted_12),
                  (_ctx.isUnread)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, "NEW"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.t('vevo.publishedAt', undefined, { date: _ctx.formatDisplayDate(_ctx.detail.publishedAt) })), 1),
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.detail.title), 1)
                ])
              ]),
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "vevo-divider" }, null, -1)),
              (_ctx.detail.dataCoverageMonths.length < 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.t('vevo.detail.coverageNote', undefined, { range: _ctx.coverageMessage })), 1))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.t('vevo.detail.caution')), 1),
              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.displayContent), 1),
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "vevo-divider" }, null, -1))
            ])
          ]))
  ]))
}